/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-toolbar[_ngcontent-%COMP%]{position:fixed;top:0;left:0;z-index:2;width:100%!important}"];
export { styles as styles };
